switchStyle(localStorage.getItem('myapp-theme')); // same key as in app.component.ts